import $ from 'jquery';
import messg from 'messg';
import 'parsleyjs';

function init() {
  const $formFeedback = $('.contactForm__form');
  const $inputName = $('input[name="uName"]');
  const $inputPhone = $('input[name="uPhone"]');
  const $inputEmail = $('input[name="uEmail"]');
  const $inputMessage = $('textarea[name="uMessage"]');
  const errorMessgClient = $('.contactForm__errorMessgClient').text();
  const errorMessgServer = $('.contactForm__errorMessgServer').text();
  const successMessg = $('.contactForm__successMessg').text();

  if ($formFeedback.length) {
    $formFeedback.parsley()

    .on('form:error', () => {
      messg.error(errorMessgClient).button('Ok');
      $('.messg').on('click', (event) => event.stopPropagation());
    })

    .on('form:success', () => {
      const name = $inputName.val();
      const phone = $inputPhone.val();
      const email = $inputEmail.val();
      const message = $inputMessage.val();

      $.post('/send-feedback', { name, phone, email, message }, (data) => {
        if (parseInt(data, 10) === 400) {
          messg.error(errorMessgServer).button('Ok');
          $('.messg').on('click', (event) => event.stopPropagation());
        } else {
          messg.success(successMessg).button('Ok');
          $inputName.val('');
          $inputPhone.val('');
          $inputEmail.val('');
          $inputMessage.val('');
        }
      });
    })

    .on('form:submit', () => false);
  }
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/contact_form/contact_form.js
 **/